import { z } from 'zod';

/**
 * Which of the six box faces receive fabric on a banquette component.
 * Every face defaults to covered; the user deselects what is hidden.
 *
 * Structurally identical to FaceSelection in utils/wrapped-surface.ts.
 * They are deliberately separate: utils stays Zod-free so it can be imported
 * anywhere. A type-parity test in wrapped-surface.test.ts keeps them in sync.
 */
export const FabricFacesSchema = z.object({
  front: z.boolean().default(true),
  back: z.boolean().default(true),
  top: z.boolean().default(true),
  bottom: z.boolean().default(true),
  left: z.boolean().default(true),
  right: z.boolean().default(true),
});

export type FabricFaces = z.infer<typeof FabricFacesSchema>;
